// extracted by mini-css-extract-plugin
export var cardHeader = "_gi-0";
export var reorderHandle = "_gi-3";
export var titleArea = "_gi-1";
export var titleAreaWithHandle = "_gi-2";